import { API_URLS } from "../../config/apiUrls";
import axiosInstance from "../../config/axios";

export const getSpecifications = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.specifications, {
      params: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const addSpecifications = (reqBody) => {
  try {
    const response = axiosInstance.post(API_URLS.specifications, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const deleteSpecifications = (reqBody) => {
  try {
    const response = axiosInstance.delete(API_URLS.specifications, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const updateSpecifications = (reqBody) => {
  try {
    const response = axiosInstance.put(API_URLS.specifications, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
